import React from 'react'
import { useNavigate } from 'react-router-dom'
import { type ClassifiedError } from '../utils/classifyError'
import { OAuthAppIcons } from './OAuthAppIcons'
import { OAuthUserBar } from './OAuthUserBar'
import { OAuthAlertBanner } from './OAuthAlertBanner'
import { OAuthErrorDetails } from './OAuthErrorDetails'
import { Button } from '../../../components/Button/Button'

interface OAuthErrorViewProps {
  classifiedError: ClassifiedError
  appName?: string
  appImageUrl?: string | null
  userName: string
  onCancel: () => void
  onTryAgain: () => void
}

export const OAuthErrorView: React.FC<OAuthErrorViewProps> = ({ classifiedError, appName, appImageUrl, userName, onCancel, onTryAgain }) => {
  const navigate = useNavigate()

  const handleGoToDashboard = () => {
    navigate('/')
  }

  return (
    <>
      <OAuthAppIcons imageUrl={appImageUrl ?? null} appName={appName ?? 'Unknown App'} />

      <h3 className='fw-bold text-center oauth-mb-40'>Connection not available</h3>

      <OAuthUserBar userName={userName} />

      <OAuthAlertBanner variant={classifiedError.alertVariant} title={classifiedError.alertTitle} body={classifiedError.alertBody} />

      <OAuthErrorDetails errorCode={classifiedError.errorCode} />

      {classifiedError.actions === 'dashboard' ? (
        <div className='d-flex justify-content-center'>
          <Button variant='primary' onClick={handleGoToDashboard}>
            Go to dashboard
          </Button>
        </div>
      ) : (
        <div className='oauth-buttons d-flex justify-content-end gap-3'>
          <Button variant='secondary' onClick={onCancel}>
            Cancel
          </Button>
          <Button variant='primary' onClick={onTryAgain}>
            Try again
          </Button>
        </div>
      )}
    </>
  )
}
